const envDependentCookies = ["accessToken", "refreshToken", "expiresAt"];

const renameEnvDependentCookie = name => {
  if (envDependentCookies.includes(name)) {
    const env = process.env.REACT_APP_ENVIRONMENT;
    if (env !== "prod") name = env + "_" + name;
  }
  return name;
};

export function setCookie(name, value, days, domain = ".routetitan.com") {
  let expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else expires = "";
  name = renameEnvDependentCookie(name);
  document.cookie =
    name +
    "=" +
    value +
    expires +
    (process.env.NODE_ENV === "production" && domain
      ? `;domain=${domain};path=/`
      : "");
}

export function getCookie(name) {
  name = renameEnvDependentCookie(name);
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function eraseCookie(name, domain = ".routetitan.com") {
  name = renameEnvDependentCookie(name);
  document.cookie =
    name +
    `=; Max-Age=-99999999${
      process.env.NODE_ENV === "production" && domain
        ? `;domain=${domain};path=/`
        : ""
    }`;
}
